import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { addSupplementToInquiry } from '@api/inquiries';
import { IAddSupplementToInquiryPayload } from '@interfaces/inquiries';

export const handleAddSupplementToInquiry = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  IAddSupplementToInquiryPayload
>('addSupplementToInquiry', addSupplementToInquiry);
